import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

const BlogEditor = ({ content, setContent }) => {

    const editor = useEditor({
        extensions: [StarterKit],
        content: content,
        onUpdate: ({ editor }) => {
            setContent(editor.getHTML());
        }
    });

    if (!editor) return null;

    return (
        <div className="border rounded p-2">

            <div className="mb-2">
                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleBold().run()}
                    className="btn btn-sm btn-light me-2"
                >
                    Bold
                </button>

                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleItalic().run()}
                    className="btn btn-sm btn-light me-2"
                >
                    Italic
                </button>

                <button
                    type="button"
                    onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                    className="btn btn-sm btn-light"
                >
                    H2
                </button>
            </div>

            <EditorContent editor={editor} />

        </div>
    );
};

export default BlogEditor;